import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Gauge, Smartphone, ClipboardList, CheckSquare, MapPin, Menu } from "lucide-react";

const ITEMS = [
  { to: "/tableau", key: "dashboard", icon: Gauge, end: true, roles: "*" },
  { to: "/punch-mobile", key: "punch", icon: Smartphone, roles: "*" },
  { to: "/feuilles", key: "sheets", icon: ClipboardList, roles: "*" },
  { to: "/approbations", key: "approvals", icon: CheckSquare, badge: true, roles: ["foreman", "project_manager", "admin"] },
  { to: "/chantiers", key: "chantiers", icon: MapPin, roles: ["employee"] },
];

const allowed = (roles, role) => roles === "*" || roles.includes(role);

export default function BottomNav({ onMenu, user, approveCount = 0 }) {
  const { t } = useTranslation();
  const role = user?.role;
  const items = ITEMS.filter((i) => allowed(i.roles, role)).slice(0, 4);
  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <NavLink key={it.to} to={it.to} end={it.end} data-testid={`bn-${it.key}`}
            className={({ isActive }) => `bn-item ${isActive ? "active" : ""}`}>
            <span className="bn-ico-wrap">
              <Icon size={21} />
              {it.badge && approveCount > 0 && <span className="bn-badge">{approveCount}</span>}
            </span>
            <span className="bn-label">{t(`bottomnav.${it.key}`)}</span>
          </NavLink>
        );
      })}
      <button className="bn-item" onClick={onMenu} data-testid="bn-plus">
        <span className="bn-ico-wrap"><Menu size={21} /></span>
        <span className="bn-label">{t("bottomnav.menu")}</span>
      </button>
    </nav>
  );
}
